import './App.css';
import React, {useState, useRef, useEffect} from 'react';
import TodoList from './TodoList';
import { v4 as uuidv4 } from "uuid";

const MY_LOCAL_STORAGE_KEY = 'todoApp.todos'

function App() {
  // todos represents each one of our ToDos
  // setTodos sets each of our Todos
  const [todos, setTodos] = useState([])
  const todoNameRef = useRef()

  //Loads todo items from local storage
  useEffect(() => {
    const storedTodos = JSON.parse(localStorage.getItem(MY_LOCAL_STORAGE_KEY))
    if(storedTodos){
      setTodos(storedTodos)
    }
  },[])

  //Saves our Todos to Local Storage
  useEffect(() => {
    localStorage.setItem(MY_LOCAL_STORAGE_KEY,JSON.stringify(todos))
  },[todos])

  //Adds todo item to list
  function handleAddTodo(e){
    //Gets current value of the todoNameRef
    const name = todoNameRef.current.value
    if (name === ''){
      return
    }

    //Gives us the previous todos as well as add in the new todo
    setTodos(prevTodos => {
      //uuidv4 generates a random id
      //returns previous todos as well as the new todo
      return [...prevTodos,{id:uuidv4(),name:name,complete:false}]
    })
    //Clears the text input box
    todoNameRef.current.value = null
  }

  //Allows the user to check if the todo is complete or not
  function toggleTodo(id){
    //Creates copy of the todo array
    const newTodos = [...todos]
    const todo = newTodos.find(todo => todo.id === id)
    todo.complete = !todo.complete
    setTodos(newTodos)
  }

  //Clears the todos
  function handleClearTodos(){
    const newTodos = todos.filter(todo => !todo.complete)
    setTodos(newTodos)
  }

  return (
    // TodoList Passes our Todos
    // todos left of the equal sign is the props
    <>
      <div className="list">
        <h1>To-Do List</h1>
        <TodoList todos={todos} toggleTodo={toggleTodo}/>
        <input ref={todoNameRef} type="text" />
        <button className="addToDo" onClick={handleAddTodo}>Add Todo</button>
        <button className="clearToDo" onClick={handleClearTodos}>Clear Complete</button>
        <div>{todos.filter(todo => !todo.complete).length} left to do</div>
      </div>
    </>
  )
}

export default App;
